export function numericComparator(n1: number | null, n2: number | null): number {
  if (n1 == null && n2 == null) return 0;
  if (n1 == null) return -1;
  if (n2 == null) return 1;
  if (isNaN(n1)) return -1;
  if (isNaN(n2)) return 1;
  return n1 - n2;
}
